// extracted by mini-css-extract-plugin
export default {"Container":"UploadDiagnosticsList_Container__s5jcN"};